import { render, staticRenderFns } from "./BudgetType.vue?vue&type=template&id=a9a35a32"
import script from "./BudgetType.vue?vue&type=script&lang=js"
export * from "./BudgetType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports